import '../plugins/MicroTemplating.js';

function kebabCase(str) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
}

export default async function initMapZH() {
  const suitecaseSvgString =
    '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="51.5" viewBox="0 0 34 51.5" class="suitecase-svg"><defs><radialGradient id="a" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".102"/><stop offset="1" stop-opacity="0"/></radialGradient><radialGradient id="b" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".2"/><stop offset=".483" stop-opacity=".039"/><stop offset="1" stop-opacity="0"/></radialGradient></defs><g transform="translate(-654 -1829.5)"><ellipse cx="17" cy="7" rx="17" ry="7" transform="translate(654 1867)" fill="url(#a)"/><ellipse cx="8" cy="3" rx="8" ry="3" transform="translate(663 1870.5)" fill="url(#b)"/></g><path class="marker" d="M33.5 16.5c0 7.511-10.055 20.883-14.463 26.4a2.6 2.6 0 0 1-4.073 0C10.555 37.383.5 24.011.5 16.5a16.5 16.5 0 0 1 33 0Z" fill="#fff"/><path class="icon" d="M14.563 11.5H14v2.25h-3v9h12v-9h-3V11.5h-5.437Zm4.313 2.25h-3.75v-1.125h3.75Z" fill="#1a1a1a"/></svg>';
  const buildingSvgString =
    '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="51.5" viewBox="0 0 34 51.5"><defs><radialGradient id="a" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".102"/><stop offset="1" stop-opacity="0"/></radialGradient><radialGradient id="b" cx=".5" cy=".5" r=".5" gradientUnits="objectBoundingBox"><stop offset="0" stop-opacity=".2"/><stop offset=".483" stop-opacity=".039"/><stop offset="1" stop-opacity="0"/></radialGradient></defs><g transform="translate(-654 -1829.5)"><ellipse cx="17" cy="7" rx="17" ry="7" transform="translate(654 1867)" fill="url(#a)"/><ellipse cx="8" cy="3" rx="8" ry="3" transform="translate(663 1870.5)" fill="url(#b)"/></g><path class="marker" d="M33.5 16.5c0 7.511-10.055 20.883-14.463 26.4a2.6 2.6 0 0 1-4.073 0C10.555 37.383.5 24.011.5 16.5a16.5 16.5 0 0 1 33 0Z" fill="#1a1a1a"/><path class="icon" d="M23 11.5h-7.5v3H11v9h12v-12Zm-10.5 6.75H14v1.5h-1.5Zm6 .75H17v-1.5h1.5Zm1.5 0v-1.5h1.5V19Zm-6-3v1.5h-1.5V16Zm3-3h1.5v1.5H17Zm4.5 0v1.5H20V13ZM17 16.75v-1.5h1.5v1.5Zm4.5 0H20v-1.5h1.5Z" fill="#fff"/></svg>';

  document.querySelector('.section-contact').addEventListener('click', function (e) {
    if (e.target.classList.contains('js-contact-btn')) {
      // trigger the contact form modal on the dynamic map markers templates
      const trigger = e.target.dataset.trigger;
      document.querySelector(`.form-contact-page[data-contact="${trigger}"]`).click();
    }
  });

  jQuery('.js-map-holder:has(#map)')
    .each((i, section) => {
      getCsrf()
        .then(result => {
          let query = `
            query Addresses {
              entries(section: "addresses") {
                ... on address_Entry {
                  uid
                  title
                  function
                  addressCategories {
                    uid
                  }
                  address
                  country {
                    uid
                    title
                  }
                  responsibleForCountries {
                    uid
                    title
                  }
                  email
                  phone
                  mobile
                  fax
                  lat
                  lng
                  note
                }
              }
            }
          `;
          loadData(query, result.name, result.value, section.dataset.site ?? '')
            .then(data => {
              const markers = data.data.entries;
              renderMarkers(markers);
            });
        });
      const $section = jQuery(section);
      const $selectContinent = $section.find('#map-continent');
      const $selectCountry = $section.find('#map-country');
      const $mainContactsContainer = document.getElementById('js-main-contacts');
      const $tmplMainContact = $section.find('[data-tmpl-main]').html();

      async function getCsrf() {
        const response = await fetch('/actions/frontend/site/get-csrf/', {
          method: 'POST'
        });
        return response.json();
      }

      async function loadData(query = '', csrfName, csrfValue, siteUrl = '') {
        const response = await fetch(`${siteUrl.replace(/\/$/, '')}/graphql/`, {
          method: 'POST',
          headers: {
            csrfName: csrfValue,
            'Content-Type': 'application/graphql',
          },
          body: query
        });
        return response.json();
      }

      function renderMarkers(data) {

        const markers = data.map((markerData, i) => {
          // remove null values from graphQl
          Object.keys(markerData).forEach((k) => markerData[k] == null && delete markerData[k]);
          // skip address if it doesn't have lat and lng
          if (markerData.lat && markerData.lng) {

            // flatten the country data in a new variable, original is needed for $tmplMainContact
            markerData.countries = [...new Set([...markerData.country.map((country) => {return country.uid;}), ...markerData.responsibleForCountries.map((country) => {return country.uid;})])];
            // only keep the lvl2 country for the $tmplMainContact
            markerData.country = markerData.country.map((country) => {return country.title;});
            markerData.country = Array.from(markerData.country).pop();
            // flatten the addressCategories data and collect all available options
            markerData.addressCategories = markerData.addressCategories.map((category) => {
              return category.uid;
            });

            markerData.icon = suitecaseSvgString;

            return markerData;
          }
        }).filter(item => item !== undefined);


        // initial filtering
        filterMarkers(markers);

        $selectContinent.on('change', filterCountrySelect);
        $selectContinent.removeAttr('disabled');
        $selectContinent.on('change', filterMarkers.bind(null, markers));
        $selectCountry.on('change', filterMarkers.bind(null, markers));
        $selectCountry[0].disabled = $selectContinent[0].selectedIndex === 0;
      }

      function filterCountrySelect() {
        const options = $selectCountry[0].options;
        for (let option of options) {
          option.classList.add('d-none');
          if (option.dataset.parent === $selectContinent[0].value) {
            option.classList.remove('d-none');
          }
        }
        $selectCountry[0].selectedIndex = 0;
        $selectCountry[0].disabled = false;
      }

      function filterMarkers(markers = [], cluster = {}) {
        const continent = $selectContinent[0].selectedOptions[0];
        const country = $selectCountry[0].selectedOptions[0];
        const continentValue = continent.value;
        const countryValue = country.value;
        const countrySorting = country.dataset.sort;
        let mainContactsTmpl = [];

        let mainContacts = JSON.parse(document.getElementById('main-contacts').dataset.contacts);
        if (countryValue) {
          mainContacts = JSON.parse(country.dataset.contacts);
        } else if (continentValue) {
          mainContacts = JSON.parse(continent.dataset.contacts);
        }

        markers.filter(markerDataset => {
          const foundAsMain = markerDataset.uid in mainContacts;

          if (foundAsMain) {
            if (countryValue) {
              mainContactsTmpl.push(tmpl($tmplMainContact, { data: markerDataset }));
            }
          }
        });

        renderMainContacts(mainContactsTmpl);
        updateContacts(continentValue, countryValue, countrySorting);
      }

      function updateContacts(continent, country, sorting) {
        // hide addresses unrelated to the continent and country
        const $addresses = document.querySelectorAll('#accordionContacts [data-country]');
        for (const address of $addresses) {
          address.classList.add('d-none');
          if (address.dataset.country.includes(continent) && address.dataset.country.includes(country)) {
            address.classList.remove('d-none');
          }
        }

        const $groups = document.querySelectorAll('#accordionContacts .accordion-item');
        for (const group of $groups) {
          // hide contact groups without related addresses
          const addressesHidden = group.querySelectorAll('.contact:not(.d-none)');
          group.classList.add('d-none');
          if (addressesHidden.length !== 0) {
            group.classList.remove('d-none');
          }

          // change the sorting of the addresses
          // let addressesAll = group.querySelectorAll('.contact');
          // if (sorting === 'postalCode') {
          //   addressesAll = Array.from(addressesAll).sort(function (a, b) {
          //     return a.dataset.zip > b.dataset.zip ? 1 : -1;
          //   });
          // } else {
          //   addressesAll = Array.from(addressesAll).sort(function (a, b) {
          //     return a.dataset.title > b.dataset.title ? 1 : -1;
          //   });
          // }
          // group.querySelectorAll('.row.gy-7')[0].innerHTML = addressesAll.map(e => e.outerHTML).join('');
        }
      }

      function renderMainContacts(data = []) {
        $mainContactsContainer.innerHTML = data.join('');
      }
    });

}
